import React from 'react';
import { FaInstagram } from 'react-icons/fa';

function Footer() {
    return (
        <footer className="footer-custom mt-auto py-4">
            <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
                <div className="mb-3 mb-md-0 text-white footer-item">
                    <strong>© {new Date().getFullYear()} Shiny Squad Cleaning</strong><br />
                    <strong>Orem, Utah — Serving Utah County</strong>
                </div>

                <div className="mb-3 mb-md-0 footer-item">
                    <a href="mailto:shinysquadcleaning@gmail.com" className="me-3 text-decoration-none text-white">
                        shinysquadcleaning@gmail.com
                    </a>
                    <span className="me-3 text-white">|</span>
                    <a href="tel:+13854501232" className="text-decoration-none text-white">
                        (385) 450-1232
                    </a>
                </div>

                <div className="footer-item">
                    <a
                        href="https://instagram.com/shinysquadcleaning"
                        target="_blank"
                        rel="noreferrer"
                        className="text-white"
                        aria-label="Instagram"
                    >
                        <FaInstagram size={24} />
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
